import * as React from "react";
import type { AdminRole } from "@/providers/types";

const ROLE_DESCRIPTIONS: Record<AdminRole, string> = {
  support: "Просмотр пользователей, выдача компенсаций",
  moderator: "Модерация контента, блокировка пользователей",
  analyst: "Просмотр дашборда и аудит-лога",
  superadmin: "Полный доступ ко всем разделам",
};

const ALL_ROLES: AdminRole[] = ["support", "moderator", "analyst", "superadmin"];

interface RoleSelectorProps {
  value: AdminRole;
  onChange: (role: AdminRole) => void;
  id?: string;
  disabled?: boolean;
}

export function RoleSelector({
  value,
  onChange,
  id = "role-selector",
  disabled = false,
}: RoleSelectorProps): React.JSX.Element {
  const description = ROLE_DESCRIPTIONS[value];
  const showSuperadminWarning = value === "superadmin";

  return (
    <div className="flex flex-col gap-2">
      <select
        id={id}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as AdminRole)}
        className="w-full h-11 px-3 pr-9 border border-[var(--border)] rounded-[var(--radius-sm)] text-[14px] font-[var(--font)] text-[var(--fg)] bg-[var(--surface)] appearance-none cursor-pointer focus:border-[var(--accent)] focus:outline-none focus:ring-2 focus:ring-[var(--accent-weak)] disabled:opacity-50 disabled:cursor-not-allowed"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='rgba(0,0,0,0.52)' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 12px center",
        }}
      >
        {ALL_ROLES.map((role) => (
          <option key={role} value={role}>
            {role}
          </option>
        ))}
      </select>

      {description && (
        <p className="text-[12px] text-[var(--muted)] leading-[1.4] px-3 py-2 bg-[var(--surface-2)] rounded-[var(--radius-sm)] border border-[var(--border)]">
          {description}
        </p>
      )}

      {showSuperadminWarning && (
        <div
          role="alert"
          className="flex items-start gap-2.5 px-3.5 py-3 bg-[rgba(196,138,26,0.08)] border border-[rgba(196,138,26,0.20)] rounded-[var(--radius-sm)] text-[13px] text-[var(--warn)] leading-[1.4]"
        >
          <svg
            className="w-[18px] h-[18px] flex-shrink-0 mt-px"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            aria-hidden="true"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          <span>Superadmin имеет полный доступ ко всем данным и действиям</span>
        </div>
      )}
    </div>
  );
}
